import React from "react";
import RevealAnimation from "../RevealAnimation";
import "./comparisonTable.scss";
import {
  FiCheck,
  FiX,
  FiDollarSign,
  FiTrendingUp,
  FiUsers,
  FiPackage,
  FiClock,
  FiAlertTriangle,
  FiTarget,
  FiBarChart2,
  FiAward,
} from "react-icons/fi";

const ComparisonTable = () => {
  const comparisonData = [
    {
      dimension: "What VC Provides",
      icon: <FiDollarSign />,
      vc1: "Cash only",
      vc2: "Capability + Capital + Strategy + Execution",
      highlight: true,
    },
    {
      dimension: "Founder Support",
      icon: <FiUsers />,
      vc1: "Minimal",
      vc2: "Full engineering + strategy support",
    },
    {
      dimension: "Execution",
      icon: <FiTarget />,
      vc1: "Founder must hire team",
      vc2: "Powerhouse team ready Day 1",
    },
    {
      dimension: "Product",
      icon: <FiPackage />,
      vc1: "MVP",
      vc2: "MMP (marketable, scalable product)",
    },
    {
      dimension: "Time to Market",
      icon: <FiClock />,
      vc1: "Slow",
      vc2: "Fast, assisted by AI delivery",
    },
    {
      dimension: "Risk",
      icon: <FiAlertTriangle />,
      vc1: "High",
      vc2: "TRL-scored, de-risked",
    },
    {
      dimension: "Team Formation",
      icon: <FiUsers />,
      vc1: "Months",
      vc2: "Immediate",
    },
    {
      dimension: "Scaling",
      icon: <FiTrendingUp />,
      vc1: "Figure it out",
      vc2: "BOT → GCC roadmap",
    },
    {
      dimension: "Investor Readiness",
      icon: <FiBarChart2 />,
      vc1: "Weak",
      vc2: "Strong metrics, architecture, and growth",
    },
    {
      dimension: "Value Add",
      icon: <FiAward />,
      vc1: "Advice",
      vc2: "Strategy + architecture + engineering",
    },
  ];

  return (
    <section className="comparison-table-section" id="comparison">
      <div className="body-container">
        <RevealAnimation>
          <div className="section-header">
            <h2>VC 1.0 vs VC 2.0</h2>
          </div>
        </RevealAnimation>

        <div className="table-scroll-container">
          <div className="comparison-grid">
            {/* Header Row */}
            <div className="grid-header">
              <div className="header-cell dimension-header">
                <span>Dimension</span>
              </div>
              <div className="header-cell vc1-header">
                <span className="vc-badge old">Traditional (VC 1.0)</span>
              </div>
              <div className="header-cell vc2-header">
                <div className="recommended-badge">Recommended</div>
                <span className="vc-badge new">ventureRyte (VC 2.0)</span>
              </div>
            </div>

            {/* Data Rows */}
            {comparisonData.map((row, index) => (
              <RevealAnimation key={index} delay={0.1 + index * 0.05}>
                <div
                  className={`comparison-row ${
                    row.highlight ? "highlighted" : ""
                  }`}
                >
                  <div className="dimension-cell">
                    <span className="dimension-icon">{row.icon}</span>
                    <span className="dimension-text">{row.dimension}</span>
                  </div>
                  <div className="vc1-cell">
                    <span className="cell-content">{row.vc1}</span>
                  </div>
                  <div className="vc2-cell">
                    <span className="cell-content">{row.vc2}</span>
                  </div>
                </div>
              </RevealAnimation>
            ))}
          </div>
        </div>

        <RevealAnimation delay={0.2}>
          <div className="comparison-summary">
            <div className="summary-card">
              <div className="summary-content">
                <RevealAnimation delay={0.3}>
                  <div className="traditional-text">VC 1.0 gives money.</div>
                </RevealAnimation>
                <RevealAnimation delay={0.5}>
                  <div className="ventureryte-text">
                    ventureRyte VC 2.0 gives{" "}
                    <span className="highlight-text">outcomes.</span>
                  </div>
                </RevealAnimation>
              </div>
            </div>
          </div>
        </RevealAnimation>
      </div>
    </section>
  );
};

export default ComparisonTable;
